exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-button-container[data-v-3f15377c]{height:75px;width:140%;background-color:#fff;margin-left:-1.5rem;padding-left:26px;border-top:1px solid #cfcfcf}h1[data-v-3f15377c]{height:21px}.list-container[data-v-3f15377c]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f15377c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/UserList.vue
// module id = 763
// module chunks = 0